var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "el-dialog-tip",
      attrs: {
        visible: _vm.dialogVisible,
        width: _vm.width,
        "show-close": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "el-result",
        {
          attrs: {
            icon: "success",
            title: "提交成功",
            subTitle: "请根据提示进行操作"
          }
        },
        [
          _c(
            "template",
            { slot: "icon" },
            [
              _c("el-image", {
                staticStyle: { width: "68px" },
                attrs: { src: _vm.imgSrc }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("template", { slot: "subTitle" }, [
            _c("span", { staticStyle: { color: "#5D6494" } }, [
              _vm._v("我们将尽快与您联系 (" + _vm._s(_vm.time) + "s) ")
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-daaa4610", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-daaa4610","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/tipSuccess.vue
// module id = null
// module chunks = 